import { type BaseQueryFn, createApi, type FetchArgs, fetchBaseQuery, type FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { API_URL, STORAGE_KEYS } from '../constants';

const PUBLIC_AUTH_ENDPOINTS = [
  'login',
  'signup',
  'verifyOtp',
  'confirmPassword',
  'resetPassword',
  'resendOtp',
  'getCms',
  'getFaqs',
];

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { endpoint }) => {
    const token = localStorage.getItem(STORAGE_KEYS.token);

    headers.set('Accept-Language', 'en');
    headers.set('Device-Type', 'WEB');

    if (token && token !== 'undefined' && token !== 'null' && !PUBLIC_AUTH_ENDPOINTS.includes(endpoint)) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs | any, unknown, FetchBaseQueryError> = async (
  args, api, extraOptions
) => {
  const result = await baseQuery(args, api, extraOptions);

  // Wrong login/signup credentials also return 401. Do not hard-reload the page
  // or the error toast never appears.
  const isPublicAuth = PUBLIC_AUTH_ENDPOINTS.includes(api.endpoint);
  const isPublicRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/public');

  if (result?.error?.status === 401 && !isPublicAuth && !isPublicRoute) {
    if (typeof window !== 'undefined') {
      try {
        localStorage.removeItem(STORAGE_KEYS.token);
      } catch (e) { }
      window.location.replace('/');
    }
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ['UNAUTHORIZED', 'UNKNOWN_ERROR', 'USER', 'DESIGNS', 'YATCHS'],
  keepUnusedDataFor: 0,
  endpoints: () => ({}), // Endpoints are injected in the services folder
});

export default emptySplitApi;
